import { TicketItemStatus, TicketStatus } from '@ancon/wildcat-types'

export default function getTicketStatusOfItemStatus(
  ticketItemStatus: TicketItemStatus,
) {
  return <TicketStatus>(ticketItemStatus as number)
}
